<template>
  <grid-panel :panel-header="utilizationHeader" :loading="loading">
    <div class="utilization-panel">
      <div class="utilization-kpi">
        <div v-if="hasNoData" class="no-data-message">
          No Data To Display
        </div>
        <v-progress-circular
          v-if="!hasNoData"
          :value="utilizationValue"
          :color="utilizationColor"
          :size="144"
          :width="10"
        >
          <div class="kpi">
            <span v-html="utilizationText"></span>
          </div>
        </v-progress-circular>
      </div>
      <div v-if="!hasNoData" class="countText">
        <div>({{ Intl.NumberFormat('en-US').format(utilizationCount) }} of {{ Intl.NumberFormat('en-US').format(utilizationLimit) }})</div>
        <div>{{ metricName }} Licenses Used</div>
      </div>
    </div>
  </grid-panel>
</template>

<script>
import GridPanel from '../../../../vueComponents/gridPanel.vue';
export default {
  name: 'utilization-panel',
  components: {
    GridPanel
  },
  props: {
    metricName: {
      type: String,
      default: () => {''}
    },
    utilizationCount: {
      type: Number,
      default: () => {0}
    },
    utilizationLimit: {
      type: Number,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasNoData: function() {
      return this.utilizationLimit < 1 && this.utilizationCount < 1;
    },
    utilizationValue: function() {
      return ((this.utilizationCount / this.utilizationLimit) || 1) * 100;
    },
    utilizationText: function() {
      if (this.utilizationLimit === 0) {
        return 'N/A';
      }
      return this.utilizationValue.toLocaleString(undefined, {notation: 'compact'}) + '<span class="percent" style="font-size: 24px;position: relative;top: -4px;">%</span>';
    },
    utilizationHeader: function() {
      return this.metricName + ' Utilization';
    },
    utilizationColor: function() {
      let percent = this.utilizationValue;
      if (percent > 100) {
        return 'var(--bad-color)';
      }
      if (percent > 85) {
        return 'var(--fair-color)';
      }
      return 'var(--good-color)';
    }
  },
}
</script>

<style lang="scss" scoped>
.utilization-panel {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .experience-score-header {
    color: var(--filter-text-color);
    font-size: 24px;
    font-weight: 800;
  }

  .utilization-kpi {
    flex-grow: 1;
    max-width: 100%;
    max-height: 190px;
    display: flex;
    justify-content: center;
    align-items: center;
    .kpi {
      font-weight: 800;
      font-size: 36px;
      color: var(--text-color);
      .percent {
        font-size: 24px;
        position: relative;
        top: -4px;
      }
    }
  }
  .countText {
    text-align: center;
    color: var(--text-color);
  }
}
</style>
